import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";

export default class Scenario4Part14 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	chapterIds = {		
		scenario4_1D_s25: 'CALM - Scenario 4 - 1D - Segment 25',
		scenario4_1D_s26: 'CALM - Scenario 4 - 1D - Segment 26'
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part14.id;
	}

	public start() {
		const context = this;
		context.segment1Step1IncomingCall();
	}

	private segment1Step1IncomingCall() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(this.chapterIds.scenario4_1D_s25, () =>
			context.segment1Step2Dialogue())
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		this.scenario.dialog(
			'CN-C13-L3-110a',
			[{
				text: 'We have completed the checklists and are ready for the visit.',				
				scoreType: ScoreType.Zero,
				isCorrect: true // Rank zero (no points awarded)
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.evaluateAnswer(selectedOption, () => context.segment3Step1GoToNSC(), context.partIndx);
			}
		);
		context.scenario.updateObjective('');
	}

	private segment3Step1GoToNSC() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_1D_s26, () => {
			context.segment3Step2EnterMoreReports();
		});
	}

	private segment3Step2EnterMoreReports() {
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'Nothing to add to report.'
				},
				{
					title: '24 Hour',
					description: 'Nothing to add to report.'
				},
				{
					title: 'End of Shift',
					description: 'Nurse Manager Trista escorted the Joint Commission Survey team through the unit.'
				}
			],
			review: {
				text:
					`
						<p class="regular-description-font" style="margin: 0;">	
						Being prepared for a Joint Commission visit is an on-going process. In this scenario, when the visit is imminent, 
						remember to <span style="color: rgb(222, 225, 156)">delegate and look for support from the staff.</span><br /><br />  
						A Charge Nurse cannot feasibly verify that everything is in order in the unit. <span style="color: rgb(222, 225, 156)">Having a 
						checklist can help quickly organize the staff and still maintain patient care.</span> <br /><br />
						<span style="color: rgb(222, 225, 156)">Review your procedures for a Joint Commission visit</span> so you’ll be prepared 
						when they arrive and be familiar with your protocols.  						
						</p>
						`
			},
			reflects: [
				{
					title: 'If the JC were to arrive at your unit right now, what is the first thing you would do?',
					answer:''
				},
				{
					title: 'Do you have a JC Checklist? Where is it located? Should you have a checklist?',
					answer: ''
				},
				{
					title: 'Where do you think your weakest area is with regards to Joint Commission standards? Why?',
					answer: ''
				},
				{
					title: 'Do you know your Joint Commission Patient Safety Goals?',
					answer: ''
				},
				{
					title: 'What was your strategy when you assigned the different JC checklist tasks to the staff members?',					
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			}
		})
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx] + this.scenario.delegateUIScore;

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = null;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {
			var badges = context.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].badges;
			for (var indx = 0; indx < badges.length; indx++) {
				badges[indx].isUnlocked = true;
			}
			context.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = null;
			context.scenario.gameManager.UiManager.destroyAllInstances();
			context.scenario.unlockNextLevel();
			context.scenario.update508Window(Window508Type.EndLevelUI);
			context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.EndLevelUI, {
				level: context.scenario.currentLevel,
				badges: badges,
				onExitGameClicked: () => {
					context.scenario.exitGame();
				},
				onNextLevelClicked: () => {
					context.scenario.nextLevel();
					context.onDone();
				}
			});
		});
	}
}